import React, { useState, useRef, useEffect } from "react";
import { IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/MegaMenu";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "owl.carousel"; // Import Owl Carousel AFTER jQuery
import OwlCarousel from "react-owl-carousel";
// import '../outterpages.css'
// import curreciesBan from '../../../assets/Images/Outterpage/currencies-banner-img.png';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from "@mui/material/styles";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Stack from '@mui/material/Stack';
import eng from '../../../assets/Images/Outterpage/eng.webp'
import jap from '../../../assets/Images/Outterpage/jap.webp'
import cardimg from '../../../assets/Images/Outterpage/card-1.webp'
import sec4 from '../../../assets/Images/Outterpage/sec-4-img.webp'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import cpbanner from '../../../assets/Images/Outterpage/cpy-trading-banner.webp'
import sec2cp from '../../../assets/Images/Outterpage/cp-trade-sec-2.webp'
import star from '../../../assets/Images/Outterpage/cp-star.webp'
import imgcrn from '../../../assets/Images/Outterpage/img-crn.webp'
import { useScroll, useTransform, motion, useInView } from 'framer-motion'
import aboutbanner from '../../../assets/Images/Outterpage/about-banner.webp'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "1px solid  rgba(255, 146, 71, 1)  ",
    '&:nth-of-type(odd)': {
        background: "linear-gradient(90deg,rgba(99, 97, 97, 0.44) 15.1%,rgba(70, 69, 68, 0.49) 85.42%)",
    },
    // Hide the last border of the table
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

// const videos = [
//   { id: 1, src: video1 },
//   { id: 2, src: video2 },
//   { id: 3, src: video3 },
//   { id: 3, src: video4 },
// ];
const testimonials = [
    {
        name: "Sherly",
        position: "CEO",
        text: "Figma ipsum component variant main layer. Library figjam subtract font rotate move auto. Figjam strikethrough bullet text device pen scale. Group horizontal link library flows ellipse flatten library undo.",
    },
    {
        name: "Carlos",
        position: "Product Manager",
        text: "An amazing experience! The support and innovation mindset Rishi brings to the team makes every project more exciting and successful.",
    },
    // {
    //   name: "Rishi",
    //   position: "CEO",
    //   text: "Regulus has truly streamlined my trading activity. The platform is incredibly user-friendly, making it easy to navigate and execute trades quickly. I've seen a noticeable improvement in my efficiency!",
    // },
];

const options = {
    margin: 50,
    items: 1,
    autoplay: true,
    autoplayTimeout: 6000,
    dots: false, // Hide default dots
    loop: true,
    smartSpeed: 800,
    nav: true, // We will use custom navigation
    responsive: {
        0: {
            dots: true,
            nav: false,
        },
        768: {
            dots: false,
            nav: true,
        },
    },
};

const marketData = [
    { id: 1, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 2, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 3, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 4, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 5, pair: "GBP/USD", value: "1,120.65", trend: "down" },
];


const tableData = [
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },

]
const accordianData = [
    {
        question: "How Does Copy Trading Work?",
        answer: "Copy trading enables users to automatically replicate trades made by experienced traders. When a selected trader executes a trade, it is mirrored in the follower's account, reflecting the same actions in real-time.",
        panel: "panel1"
    },
    {
        question: "Is Copy Trading Suitable for Beginners?",
        answer: "Yes, copy trading can be advantageous for beginners by enabling them to learn from expert strategies and potentially earn while gaining market insights. However, it's important to understand the associated risks.",
        panel: "panel2"
    },



]
const cardset = [
    {

        head: "Competitive commission structure",
        para: "Figma ipsum component variant main layer. Component component horizontal slice library. Project shadow export fill selection figma hand ellipse font."
    },
    {

        head: "Wide range of marketing materials",
        para: "Figma ipsum component variant main layer. Component component horizontal slice library. Project shadow export fill selection figma hand ellipse font."
    },
    {

        head: "Real-time tracking and reporting",
        para: "Figma ipsum component variant main layer. Component component horizontal slice library. Project shadow export fill selection figma hand ellipse font."
    },

    {

        head: "Dedicated support",
        para: "Figma ipsum component variant main layer. Component component horizontal slice library. Project shadow export fill selection figma hand ellipse font."
    },

    {

        head: "Flexible payment options",
        para: "Figma ipsum component variant main layer. Component component horizontal slice library. Project shadow export fill selection figma hand ellipse font."
    },

    {

        head: "No minimum payout",
        para: "Figma ipsum component variant main layer. Component component horizontal slice library. Project shadow export fill selection figma hand ellipse font."
    },


]
const AffliateProgram = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const md900 = useMediaQuery(theme.breakpoints.up("900"));
    const lg1400 = useMediaQuery(theme.breakpoints.up("1400"));
    const xl = useMediaQuery(theme.breakpoints.up("xl"));
    const [expanded, setExpanded] = React.useState('panel1');
    const lg1200 = useMediaQuery(theme.breakpoints.up("1200"));
    const md1200 = useMediaQuery(theme.breakpoints.down("1200"));
    const xs375 = useMediaQuery(theme.breakpoints.up("380.99"));

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };


    const keyMap = { a: 'cd1', b: 'cd2', c: 'cd3', d: 'cd4' };

    // Create separate refs
    const refA = useRef(null);
    const refB = useRef(null);
    const refC = useRef(null);
    const refD = useRef(null);

    // Use useInView for each
    const isInViewA = useInView(refA, { once: true });
    const isInViewB = useInView(refB, { once: true });
    const isInViewC = useInView(refC, { once: true });
    const isInViewD = useInView(refD, { once: true });

    return (
        <div className="OutterPage">
            <Header />
            <div className="bg-outer">
                <section className="banner outter-banner">
                    <div className="contain-width">
                        <Grid container sx={{ alignItems: "flexStart" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} sx={{ placeContent: "center" }}>
                                <div
                                    className="banner-left "
                                    style={{ height: xl ? "500px" : "auto", placeContent: "center" }}
                                >
                                    <p>Partner</p>
                                    <h1 className="mb-30 mt-10">
                                        <span> Affiliate</span> Program
                                    </h1>
                                    <p>Affiliates are rewarded by Finowiz for referring customers. We offer you the chance to earn both CPA and commissions on the trading activity of your referrals since we respect the business that you bring.</p>
                                    <div
                                        className="display-1 btn flex-wrap mt-20"
                                        style={{ marginBottom: matches ? "40px" : "20px" }}
                                    >
                                        <Link to="#" className="bg-btn">
                                            Join Now
                                        </Link>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                                <div className="text-center ">
                                    <img width="90%" src={aboutbanner} />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </section>
                <section className="trade-easy sec-3">
                    <div className="contain-width">
                        <div className="heading">
                            <p>Our Services</p>
                            <h2>
                                Why <span>Choose US ?</span>
                            </h2>
                            <p>Figma ipsum component variant main layer. Prototype share asset stroke distribute star create. Rectangle stroke auto figjam project library select. </p>

                        </div>
                        <Grid container spacing={5} className="mt-50">

                            {
                                cardset.map((item) => (
                                    <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                        <div>
                                            <img src={cardimg} />
                                        </div>
                                        <p className="mt-10 head"><span className="grd">{item.head}</span></p>
                                        <p className="mt-10">{item.para}</p>

                                    </Grid>
                                ))
                            }

                        </Grid>


                    </div>
                </section>
                <section className="trade-easy sec-3 cp-2 we-offers">
                    <div className="contain-width">
                        <Grid container spacing={2} sx={{ flexDirection: !md900 && "column-reverse" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} sx={{ placeContent: !lg1400 && "center" }}>
                                <div>
                                    <img width="100%" src={sec2cp} />
                                </div>
                            </Grid>

                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} >
                                <div className="heading mt-30">
                                    <h2>
                                        What we offer?
                                    </h2>
                                    <p>
                                        Figma ipsum component variant main layer. Component component horizontal slice library. Project shadow export fill selection figma hand ellipse font.
                                    </p>
                                </div>
                                <Grid container>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                        <div className="display-1 mt-20">
                                            <img src={star} />
                                            <p>Simple integration and no initial outlay.</p>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                        <div className="display-1 mt-20">
                                            <img src={star} />
                                            <p>FoReal-time online account application tracking for your customers via the affiliate portal..llow Expert Strategies</p>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                        <div className="display-1 mt-20">
                                            <img src={star} />
                                            <p>Devoted multilingual assistance.</p>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                        <div className="display-1 mt-20">
                                            <img src={star} />
                                            <p>Banners, marketing content, landing pages, and other marketing tools are available.</p>
                                        </div>
                                    </Grid>

                                </Grid>

                            </Grid>

                        </Grid>

                    </div>
                </section>
                <section className="trade-easy sec-3  roadmap-bg2  ">
                    <div className="contain-width">
                        <div className="heading">
                            {/* <p>
                                <span>INSTALL</span>
                            </p> */}
                            <h2>
                                Steps to avail tradable bonus
                            </h2>

                        </div>
                        <Grid container spacing={5} className="card-set-aff">
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 7, xl: 9 }} className="mt-box ">
                                <span className="crn-alg">
                                    {
                                        xs375 && <span className="crn-box">
                                            <img width="90%" src={imgcrn} />
                                        </span>
                                    }
                                    <div className="txt-content" style={{ padding: "30px 60px", textAlign: "center" }}>
                                        <p>Step 2</p>
                                        <p><span className="grd">Start promoting our offerings</span></p>
                                    </div>
                                </span>
                            </Grid>
                                 <Grid size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 3 }} className="mt-box ">
                                <span className="crn-alg">
                                    {
                                        xs375 && <span className="crn-box">
                                            <img width="90%" src={imgcrn} />
                                        </span>
                                    }
                                    <div className="txt-content" style={{ padding: "30px 60px", textAlign: "center" }}>
                                        <p>Step 4</p>
                                        <p><span className="grd">Receive your CPA</span></p>
                                    </div>
                                </span>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 3 }} className={md1200 ? "mt-box" : "mt-box mt-50 "}>
                                <span className="crn-alg">
                                    {
                                        xs375 && <span className="crn-box">
                                            <img width="90%" src={imgcrn} />
                                        </span>
                                    }
                                    <div className="txt-content" style={{ padding: "30px 60px", textAlign: "center" }}>
                                        <p>Step 1</p>
                                        <p><span className="grd">Register</span></p>
                                    </div>
                                </span>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 7, xl: 9 }} className={md1200 ? "mt-box" : "mt-box mt-50 "}>
                                <span className="crn-alg">
                                    {
                                        xs375 && <span className="crn-box">
                                            <img width="90%" src={imgcrn} />
                                        </span>
                                    }
                                    <div className="txt-content" style={{ padding: "30px 60px", textAlign: "center" }}>
                                        <p>Step 3</p>
                                        <p><span className="grd">Build your network</span></p>
                                    </div>
                                </span>
                            </Grid>
                        </Grid>


                    </div>
                </section>

            </div>


            <section class="cta-sec2 out-cta">
                <div className="contain-width">
                    <Grid container spacing={8}>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <label>Your Partner in Trading Success</label>
                            <h2 >Register Now for Seamless Trading with Finowiz</h2>
                            <Link to="#" className="brd-btn" >
                                Register Now
                            </Link>
                        </Grid>
                    </Grid>
                </div>
            </section>


            <Footer />
        </div>
    );
};

export default AffliateProgram;
